<chapter-step
  [title]="'Auto-approve hours that match the schedule?' | translate"
  [nextButtonLoading]="nextButtonLoading"
  [nextButtonDisabled]="autoApproveHours.value === null"
  (next)="onNext()"
>
  <p class="m-0 text-base">
    {{
      'Auto-approval works best for predictable shifts. Turn off if clocked hours often vary from schedule' | translate
    }}
  </p>
  <div class="flex flex-col gap-2">
    @for (option of autoApproveHoursOptions; track option.value) {
      <chapter-radio-button name="time-tracking-auto-approve" [control]="autoApproveHours" [data]="option" />
    }
  </div>
</chapter-step>
